export const ensureArray = (value: string | string[]) => {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value;
  }
  if (value.includes(",")) {
    return value.split(",");
  }
  return [value];
};
